import {useState, FormEventHandler, useMemo,  useRef, useEffect,} from 'react';
import dayjs from 'dayjs';
import { DropDown, Table, SidebarDrawer } from '../common';
import {ExpenseFilter, IExpense, IPaginationMeta} from '../../@types';
import { AddSquareIcon, DownloadIcon, FilterIcon } from '../../assets/icons';
import { Link } from 'react-router-dom';
import React from 'react';
import ExpenseFilterComponent from './ExpenseFilterComponent';
import { getExpenseType } from '../../utils';
import { useNavigate } from 'react-router-dom';
import {Filter} from "../../@types/invoice";
import useNotifications from '../../hooks/UseNotifications';
import DropdownButton from '../common/Table/MobileTableComponent/DropdownOptions';
import { UploadTransactionEvidence } from '../payments/RecordPayment/Upload';

interface expenseTableProps {
  expenses: IExpense[];
  isLoading: boolean;
  fetchMoreData: (page: string, cursor?: string, _backCursor?: string) => void;
  meta: IPaginationMeta;
  onSearchData: (text: string) => void;
  isSearching: boolean | undefined;
  showHead?: true | undefined;
  handleFilter: (filter: Filter) => void;
  handleSort?: (text: string) => void;
  handleSearch?: (text: string) => void;
  searchResult: IExpense[];
  selectedFilter?: ExpenseFilter | undefined;
  id? :string;

}

const ExpenseTable = ({
  expenses,
  isLoading,
  fetchMoreData,
  meta,
  selectedFilter,
  searchResult,
  handleSearch,
  handleSort,
  handleFilter,

}: expenseTableProps) => {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [showUploadPopup, setShowUploadPopup] = useState(false);
  const [showFilter, setShowFilter] = React.useState(false);
  const [type, setType] = React.useState(false)
  const [paymentMethod, setPaymentMethod] = React.useState<string>('');
  const [, setSelectedExpense] = useState<IExpense | null>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [triggerAction, setTriggerAction] = useState<boolean>(true)
  const [dropdown, setDropdown] = React.useState(false);
  const [showNestedDropdown, setShowNestedDropdown] = useState(false);


  const handleCreatedAtClick = (exp: IExpense) => {
    setSelectedExpense(exp)
  };
  const memoizedSelectedFilter = useMemo(() => selectedFilter, [
    selectedFilter?.billable, selectedFilter?.paymentMethod]);

  const handleIsReoccurringChange = (newPaymentMethod: string) => {
    setPaymentMethod(newPaymentMethod);
  };
  const handleTypeChange = (type: boolean) => {
    setType(type);
  };
  const onSearch = (text: string) => {
    if (handleSearch) {
      handleSearch(text);
    }
  };

  const renderExpensesData = () => {
    return expenses.map((expense: IExpense) => {
   
      const type = getExpenseType(expense.isBillable); 
      return {
        createdAt: (
          <a
            href={`/expenses/${expense.id}/view`}
            className="xl:text-violet-800"
            onClick={() => handleCreatedAtClick(expense)}
          >
            {dayjs(expense.createdAt).format('MM/DD/YYYY')}
          </a>
      ),
      category: expense.category,
      companyId: expense.companyId,
      id: expense.id,
      name: (
        <a 
        href={`/expenses/${expense.id}/view`}
        className="text-violet-800"
        onClick={() => handleCreatedAtClick(expense)}
        >
          {expense.vendorName}
        </a>
      ),
      paymentMethod: expense.paymentMethod,
       type: type,
      
      vendor: expense.vendorName,
      amount: `₦${expense.amount?.toLocaleString()}`,
      }
    });
  };


  

  const renderExpensesTableHead = () => {
    return {
      createdAt: { title: ' DATE' },
      category: { title: 'CATEGORY' },
      name: { title: 'VENDOR' },
      paymentMethod: { title: 'PAYMENT METHOD' },
      type: { title: 'TYPE' },
      // customer: { title: 'CUSTOMER' },
      amount: { title: 'AMOUNT' },
    };
  };

  const handleNewExpenseClick = () => {
    setShowPopup(!showPopup);
  };

  const handleSearchSelect = (item: any) => {
       navigate(`/expenses/${item.id}/view`);
  };

  const onExpenseFilterSubmit: FormEventHandler<HTMLFormElement> = (e) => {
    e.preventDefault();
    handleFilter({paymentMethod, billable: type});
    setShowFilter(false);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
      setShowPopup(false);
    }
  };


  React.useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleCloseModal = () => {
    setShowFilter(false); 
  };
  const handleFilterIconClick = () => {
    setShowFilter(true); 
  };

  useNotifications(triggerAction)


  const openUploadModal = () => {
    setShowUploadPopup(true);
  };

  const closeUploadModal = () => {
    setShowUploadPopup(false);
  };

  const handleNewUploadExpense =  ( isUploadedPayment: boolean ) => {
    setShowUploadPopup(false);
    setTriggerAction(true)
  };

  useEffect(() => {
    

    return () => {
      setTriggerAction(false)
    } 
  },[])



const toggleNestedDropdown = () => {
  setShowNestedDropdown(!showNestedDropdown);
};
const toggleDropdown = () => {
  setDropdown((prev) => !prev);
};
  return (
    <>
      <div>
        <div className='hidden md:block'>
      <Table
         
          searchPlaceHolder="Search by Vendor"
          selectedFilter={selectedFilter}
          handleFilter={handleFilter}
          searchDisplayKey={'id'}
          searchResult={searchResult}
          head={renderExpensesTableHead()}
          data={renderExpensesData()}
          handleSearchSelect={handleSearchSelect}
          isLoading={isLoading}
          showHead
          
          buttons={[
            {
              text: 'New Expense',
              icon: <AddSquareIcon />,
              onClick: handleNewExpenseClick,
            },
            {
              text: 'Import',
              icon: <DownloadIcon />,
            },
            {
              text: '',
              icon: (
                <DropDown 
                onChange={handleFilterIconClick}
                show={showFilter} 
                component={
                  <div className="flex items-center space-x-2">
                  <span>Filter</span>
                  <FilterIcon color="#044E97" />
                </div> }
                >
                  <ExpenseFilterComponent
                    type={memoizedSelectedFilter?.billable}
                    setType={handleTypeChange}
                    paymentMethod={memoizedSelectedFilter?.paymentMethod}
                    setPaymentMethod={handleIsReoccurringChange}
                    onSubmit={onExpenseFilterSubmit}
                    onClose={handleCloseModal}
                    showFilter
                  />


                </DropDown>
              ),
            },
          ]}
          showPagination
          handleSearch={onSearch}
          handleSort={handleSort}
          fetchMoreData={fetchMoreData}
          meta={meta}
          
        />

        </div>
        <div className="block md:hidden">
    <div className="relative">
      <button
        className="bg-[#044E97] text-[#FFFFFF] text-[16px] absolute mt-[240px] z-30 ml-[18em] flex w-11 h-11 rounded-full justify-center items-center py-[12.5px] leading-4 first-letter font-semibold"
        onClick={toggleDropdown}
      >
        {dropdown ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            className="w-6 h-6 inline-block items-center"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            className="w-6 h-6 inline-block"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 6v6m0 0v6m0-6h6m-6 0H6"
            />
          </svg>
        )}
      </button>
      {dropdown && (
        <div className="shadow-[0px 8px 16px 0px rgba(0,0,0,0.2)] w-[240px] bg-[#ffff] shadow-[0px 8px 16px 0px rgba(0,0,0,0.2)] z-[50] absolute top-[100%] left-0 ml-[2em] mt-[11em] h-fit">
          <h3 className="">
            <p
              onClick={toggleNestedDropdown}
              className="text-[#000] px-[16px] hover:text-blue-500 cursor-pointer"
            >
              New Expense
            </p>
          </h3>
          <h3 className="text-[#000] py-[12px] px-[16px] ">
            <span
              onClick={toggleNestedDropdown}
              className="cursor-pointer hover:text-blue-500"
            >
              Import
            </span>
            {showNestedDropdown && (
              <div className="bg-white border border-gray-300 mt-2 py-1 px-3 rounded shadow-md">
                <Link to="/expenses/create" className="block py-2 hover:text-blue-500">
                  Manually Create
                </Link>
                <button onClick={() => setShowUploadPopup(!showUploadPopup)}>
                  Upload Expense
                </button>
              </div>
            )}
          </h3>
        </div>  
      )}
    </div>
    <SidebarDrawer
              show={showUploadPopup}
              onClose={() => setShowUploadPopup(false)}
              title="Upload Expense"
              position={'left'}
            >
              <UploadTransactionEvidence 
              onRecordEntity={handleNewUploadExpense } 
              paymentType="expenses"
              closeModal={closeUploadModal} />
            </SidebarDrawer>


  <div className='flex md:hidden justify-center items-center'>
  
         <Table
          searchPlaceHolder="Search by Vendor"
          selectedFilter={selectedFilter}
          handleFilter={handleFilter}
          searchDisplayKey={'id'}
          searchResult={searchResult}
          head={renderExpensesTableHead()}
          data={renderExpensesData()}
          handleSearchSelect={handleSearchSelect}
          isLoading={isLoading}
          showHead
          buttons={[
            {
              text: '',
              icon: (
                <DropDown 
                onChange={handleFilterIconClick}
                show={showFilter} 
                component={
                  <div className="flex items-center space-x-2 ">
                  <span className='text-[15px]'>Filter</span>
                  <FilterIcon color="#044E97" />
                </div> }
                >
                 
                  <ExpenseFilterComponent
                    type={memoizedSelectedFilter?.billable}
                    setType={handleTypeChange}
                    paymentMethod={memoizedSelectedFilter?.paymentMethod}
                    setPaymentMethod={handleIsReoccurringChange}
                    onSubmit={onExpenseFilterSubmit}
                    onClose={handleCloseModal}
                    showFilter
                  />


                </DropDown>
              ),
            },
          ]}
          showPagination
          handleSearch={onSearch}
          handleSort={handleSort}
          fetchMoreData={fetchMoreData}
          meta={meta}
          expenseCard={true}
          hideFloatingScrollButton={true}
        />
       
        </div>  
        
        
</div>
        
        
      
        {showPopup && (
          <div ref={containerRef}>
            <div className="bg-white p-6 rounded-lg shadow-lg w-[20%] h-[110px] flex flex-col text-center justify-center fixed top-[52%] left-[23%] md:mt-[-7em]">
              <Link to="/expenses/create" className=" w-[100%] pb-[5%]">
                Manually create Expense
              </Link>
              <hr />
              <button
                onClick={() => setShowUploadPopup(!showUploadPopup)}
                className="justify-evenly text-center pt-[5%]"
              >
                Upload Expense
              </button>
            </div>
            <SidebarDrawer
              show={showUploadPopup}
              onClose={() => setShowUploadPopup(false)}
              title="Upload Expense"
              position={'left'}
            >
              <UploadTransactionEvidence 
              onRecordEntity={handleNewUploadExpense } 
              paymentType="expenses"
              closeModal={closeUploadModal} />
            </SidebarDrawer>
          </div>
        )}
      </div>
     
    </>
  );
};

export default ExpenseTable;
